import { internalLogger } from '../../../interface/v1/clientOsLogger';
import { LaunchServiceOptions, ServiceList, Service } from '../types';
import { isNative, JWebErrorHandler } from '..';
import { ServiceInstance, ServiceRoutingError } from '../types';
import { ServiceRoutingFacade } from '../facades/ServiceRoutingFacade';

export async function getAvailableServices(): Promise<Service[]> {
  if (!(await isNative())) return;

  const serviceList = await ServiceRoutingFacade.getServices();

  internalLogger?.log?.('onboarding-native-getAvailableServices: ', {
    serviceList
  });

  try {
    return JWebErrorHandler<ServiceList>(serviceList)?.services;
  } catch (error) {
    console.error('getAvailableServices error', error);
    return [];
  }
}

export async function getNativeServiceLaunchOptions(): Promise<
  LaunchServiceOptions | undefined
> {
  if (!(await isNative())) return undefined;

  const launchServiceOptionsResult =
    await ServiceRoutingFacade.getServiceInstanceLaunchOptions();

  internalLogger?.log?.('onboarding-native-getNativeServiceLaunchOptions: ', {
    launchServiceOptionsResult
  });

  const launchServiceOptions = JWebErrorHandler<LaunchServiceOptions>(
    launchServiceOptionsResult
  );

  return launchServiceOptions;
}

export async function findNativeService(serviceId: string): Promise<Service> {
  if (!(await isNative())) return;
  const nativeStages = await getAvailableServices();

  const service = nativeStages?.find?.((r) => r.id === serviceId);

  internalLogger?.log?.('onboarding-native-findNativeService: ', {
    service
  });

  return service;
}

export async function launchNativeService(
  launchServiceOptions: LaunchServiceOptions
): Promise<ServiceRoutingError | ServiceInstance | undefined> {
  if (!(await isNative())) return undefined;

  try {
    const serviceInstance = await ServiceRoutingFacade.launchService(
      launchServiceOptions
    );

    internalLogger?.log?.('onboarding-native-launchNativeService: ', {
      serviceInstance
    });

    return serviceInstance;
  } catch (error) {
    console.error('launchNativeService error', error);
    return undefined;
  }
}

export async function closeNativeOnboardingInstance(data?: {
  resultData: {
    appSessionId: string;
    serviceId: string;
    result: {
      result: string;
      xCorrelationId: string;
    };
    errorInfo?: {
      errorCode?: string;
    };
  };
}): Promise<void> {
  if (!(await isNative())) return;

  return new Promise((resolve, reject) => {
    try {
      internalLogger?.log?.('onboarding-native-closeNativeOnboardingInstance');

      // It should not be resolved since this call should close the webview that load this instance.
      ServiceRoutingFacade.closeServiceInstance(data);
    } catch (error) {
      console.error('closeNativeOnboardingInstance error', error);
      reject(error);
    }
  });
}
